import { useRef, useState } from 'react';
import { ReactComponent as LoadingSvg } from '../../../assets/svg/loading-half-status.svg';
import { ReactComponent as ValidationCheckSvg } from '../../../assets/svg/validation-check.svg';
import { SIGNUP_STEPS } from '../../../types/enum';
import { isString } from '../../../lib/validation';
import TextInput from '../../../components/textInput';
import request from '../../../lib/request';

const Nickname = ({ nickname, setNickname, setCurrentStep }) => {
  const nicknameRef = useRef(null);

  const [nicknameError, setNicknameError] = useState(false);
  const [nicknameVerified, setNicknameVerified] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleInput = (e) => {
    const value = String(e.target.value);
    setNickname(value);
    if (value) {
      setNicknameVerified(false);
      setLoading(true);
      clearTimeout(nicknameRef.current);
      nicknameRef.current = setTimeout(
        async () => await checkNickname(value),
        1500
      );
    }
  };

  const checkNickname = async (nickname) => {
    try {
      const { result } = await request.get(
        `/signup/check/duplication?nickname=${nickname}`
      );
      if (result) {
        setNicknameError(false);
        setNicknameVerified(true);
      }
      if (!result) {
        setNicknameError(true);
      }
    } catch (err) {
      console.log(err);
      setNicknameError(true);
    } finally {
      setLoading(false);
    }
  };

  const handleNext = () => {
    try {
      isString(nickname);
      setNickname(nickname.trim());
      setCurrentStep(SIGNUP_STEPS.GENDER_AGE);
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div>
      <h1 className='font-bold mb-3 text-white text-4xl'>
        What's your nickname?
      </h1>
      <div className='w-full bg-white rounded-full py-2 px-4 flex items-center justify-between'>
        <input
          type='text'
          className='w-full border-none '
          placeholder='Nickname'
          value={nickname}
          onChange={handleInput}
          maxLength={32}
        />
        {loading && (
          <LoadingSvg
            className='animate-spin opacity-15'
            width={16}
            height={16}
          />
        )}
        {nicknameVerified && (
          <div className='text-green-600 w-3 h-3'>
            <ValidationCheckSvg
              width={12}
              height={12}
            />
          </div>
        )}
      </div>
      {nicknameError && (
        <p className='text-red-600 text-sm mt-1 font-bold'>
          Nickname already exists
        </p>
      )}
      <button
        className={`w-full bg-yellow-500 text-black font-bold rounded-full hover:bg-yellow-600 transition-colors duration-200 py-3 mt-5 ${
          !nickname || nicknameError || loading
            ? 'opacity-40'
            : 'hover:bg-yellow-600 transition-colors duration-200'
        }`}
        onClick={handleNext}
        disabled={!nickname || nicknameError || loading}
      >
        Next
      </button>
    </div>
  );
};

export default Nickname;
